import React from 'react';
import './PremiumAccessPage.css';
import { useHistory } from 'react-router-dom';

const PremiumAccessPage = () => {
  const history = useHistory();

  const handleUpgrade = () => {
    history.push('payment');
  };

  return (
    <div className="premium-container">
      <div className="premium-card">
        <h1 className="premium-title">Exclusive Content</h1>
        <p className="premium-message">
          This feature is reserved for premium members. Upgrade now to unlock full access and enjoy exclusive benefits.
        </p>
        <button className="premium-button" onClick={handleUpgrade}>
          Upgrade to Premium
        </button>
      </div>
    </div>
  );
};

export default PremiumAccessPage;
